var exports = {
  "kL": "xfd349460--22a8bc--container",
  "u": "xfd349460--22a8bc--crumb",
  "UE": "xfd349460--22a8bc--arrow",
};

module.exports = exports;
